export const FILE = 'file';
export const FOLDER = 'folder';
export const FLASH = 'flash';
export const LINK = 'link';
export const PROFILE = 'profile';
export const CLOUD = 'cloud';
